"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var styled_system_1 = require("styled-system");
var asRendition_1 = require("../asRendition");
var utils_1 = require("../utils");
exports.whitespace = function (props) {
    return props.whitespace ? { whiteSpace: props.whitespace } : null;
};
exports.caps = function (props) {
    return props.caps ? { textTransform: 'uppercase', letterSpacing: '0.2em' } : null;
};
exports.bold = function (props) {
    return props.bold
        ? { fontWeight: props.theme.weights[props.theme.weights.length - 1] }
        : null;
};
exports.align = styled_system_1.responsiveStyle('text-align', 'align');
var Txt = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n"], ["\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\t", "\n\n\t", "\n\t", "\n"])), exports.align, styled_system_1.color, styled_system_1.fontSize, styled_system_1.space, utils_1.monospace, exports.whitespace, exports.caps, exports.bold);
var Base = asRendition_1.default(Txt);
Base.displayName = 'Txt';
Base.span = asRendition_1.default(Txt.withComponent('span'));
Base.p = asRendition_1.default(Txt.withComponent('p'));
exports.default = Base;
var templateObject_1;
